const DEFAULT_APP_CHECK_HOSTS = ['chat.juris.es'];

export function getAllowedAppCheckHosts(configuredHosts?: string) {
  const hosts = (configuredHosts || '')
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);

  return hosts.length ? hosts : DEFAULT_APP_CHECK_HOSTS;
}

export function shouldInitializeAppCheck(hostname: string, configuredHosts?: string) {
  const normalizedHost = hostname.trim().toLowerCase();
  return Boolean(normalizedHost) && getAllowedAppCheckHosts(configuredHosts).includes(normalizedHost);
}
